<template>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Test results</p>
        <button
          type="button"
          class="delete"
          @click="$emit('close')"/>
      </header>
      <section class="modal-card-body" style="width: 960px">
        <b-table :data="testResults">
          <b-table-column name="date" label="Date" v-slot="props">
            {{formatTimestamp(props.row.timestamp)}}
          </b-table-column>

          <b-table-column name="success" label="Result" v-slot="props">
            <span v-if="props.row.success" class="tag is-success is-light is-medium">Success</span>
            <span v-else class="tag is-danger is-light is-medium">Fail</span>
          </b-table-column>

          <b-table-column name="date" label="Meta data" v-slot="props">
            <pre class="p-2">{{props.row.metaData}}</pre>
          </b-table-column>

          <template slot="empty">
            <p>No test results yet</p>
          </template>
        </b-table>
      </section>
    </div>
</template>

<script>

import TestResultService from '@/services/TestResultService'
import moment from 'moment';
export default {
  name: 'TestResultsList',

  created() {
    this.getTestResults()
  },

  data () {
    return {
      testResults: []
    }
  },

  methods: {
    getTestResults() {
      const testJobId = this.$parent.$props.props.testJobId;
      TestResultService.getList(testJobId).then(response => {
        this.testResults = response.data;
      });
    },
    formatTimestamp(timestamp) {
      return moment.unix(timestamp).calendar();
    }
  }
}
</script>
